import React from 'react';
import { Icon } from './Icon.js';
export const IconBookOpen = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 5V20", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M2 5.27149V19.9026C5.5 18.6526 8.50314 18.6869 12.0031 20.4369C15.5031 18.6869 18.5 18.7078 22 19.9578V5.27149C18.5 3.52148 15.5 3.52148 12 5.77149C8.5 3.52148 5.5 3.52148 2 5.27149Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", fill: "none" })));
};
//# sourceMappingURL=IconBookOpen.js.map